export function useCustomMeta(path, name) {
  const route = useRoute()
  const config = useRuntimeConfig()
  const baseUrl = `${config.public.hostDomain}${config.app.baseURL}`
  const pageUrl = `${baseUrl}${route.path.replace(/^\//, '')}`
  const description = () => {
    if (path === 'top') {
      return `${metaConfig[path].description1}ゴルフ場のピンポイント天気をお届けします。1時間ごとの風予報や雷リスク、10日先までの天気予報やゴルフコンディション指数、服装予報などもご確認いただけます。コース情報や利用案内も掲載。${metaConfig[path].description2}`
    } else if (path === 'area') {
      return `${name}${metaConfig[path].description1}ゴルフ場のピンポイント天気をお届けします。1時間ごとの風予報や雷リスク、10日先までの天気予報やゴルフコンディション指数、服装予報などもご確認いただけます。コース情報や利用案内も掲載。${metaConfig[path].description2}`
    } else if (path === 'pref') {
      return `${name}${metaConfig[path].description1}ゴルフ場のピンポイント天気をお届けします。1時間ごとの風予報や雷リスク、10日先までの天気予報やゴルフコンディション指数、服装予報などもご確認いただけます。コース情報や利用案内も掲載。${metaConfig[path].description2}`
    } else if (path === 'point') {
      return `【${name}${metaConfig[path].description1}】1時間ごとの風予報や雷リスク、10日先までの天気予報やゴルフコンディション指数、服装予報などもご確認いただけます。コース情報や利用案内も掲載。${metaConfig[path].description2}`
    } else {
      return `${metaConfig[path].description1}${name}${metaConfig[path].description2}`
    }
  }
  useSeoMeta({
    ogImage: 'https://gvs.weathernews.jp/golf/image/common/golfSNS-2.png',
    ogType: 'website',
    ogSiteName: 'ウェザーニュース',
    viewport: 'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=3.0,user-scalable=yes',
    twitterCard: 'summary_large_image',
    twitterSite: '@wni_jp',
    twitterCreator: '@wni_jp',
    twitterImage: 'https://gvs.weathernews.jp/golf/image/common/golfSNS-2.png',
    fbAppId: '1500388770270212',
    appleItunesApp: 'app-id=302955766',
    appleMobileWebAppCapable: 'yes'
  })
  useSeoMeta({
    title: `${name}${metaConfig[path].title} - ウェザーニュース`,
    description: description(),
    ogTitle: `${name}${metaConfig[path].title} - ウェザーニュース`,
    ogDescription: description(),
    ogUrl: pageUrl,
    appleMobileWebAppTitle: `${name}${metaConfig[path].title}`,
    keywords: `${name}${metaConfig[path].keyword}`
  })
  useHead({
    link: [
      { rel: 'canonical', href: pageUrl },
      { rel: 'preconnect', href: config.public.siteDomain, crossorigin: 'anonymous' },
      { rel: 'dns-prefetch', href: config.public.siteDomain },
      { rel: 'dns-prefetch', href: 'https://gvs.weathernews.jp/' },
      { rel: 'dns-prefetch', href: 'https://gis.weathernews.jp' }
    ],
    meta: [
      { name: 'wntouch_enable', content: 'yes' },
      { name: 'wntouch_ch', content: 'ゴルフ天気' },
      { name: 'wntouch_icon', content: 'https://gvs.weathernews.jp/ip/myweather/img/icon_golf@2x.png' },
      { name: 'wntouch_icon_gray', content: 'https://gvs.weathernews.jp/ip/myweather/img/icon_golf_trans@2x.png' },
      { name: 'wntouch_icon_setting', content: 'https://gvs.weathernews.jp/ip/tabmenu/icon/icon_golf@2x.png' }
    ]
  })
  if (path === 'top') {
    useHead({
      meta: [
        { name: 'wntouch_title', content: '全国のゴルフ天気' },
        { name: 'wntouch_count', content: 'golf:top' },
        { name: 'wntouch_url', content: `${pageUrl}` }
      ]
    })
  } else if (path === 'point') {
    useHead({
      meta: [
        { name: 'wntouch_title', content: `${name}のゴルフ天気` },
        { name: 'wntouch_count', content: 'golf:pinpoint' },
        { name: 'wntouch_url', content: `${pageUrl}` }
      ]
    })
  }
}
